<template style="margin-bottom: 0px; height: 40px;">
  <div class="main-Menu" style="margin-left: 15px;">
    <el-tabs type="card" @edit="handleTabsEdit" @tab-click="handleClick" @tab-remove="tabRemove" v-model="activeName">
      <el-tab-pane :key="i" v-for="(item, i) in editableTabs" :label="item.title" :name="item.path" :url="item.path" :closable="i === 0 ? false : true">
        <span slot="label" @click.right.prevent="rightClick($event, i)" v-if="i > 0" class="tabtitle" :data-name="item.title">
          {{ item.title }}
        </span>
        <span slot="label" v-else>
          {{ item.title }}
        </span>
      </el-tab-pane>
    </el-tabs>
    <ul class="menu" v-show="menuVisible" id="menu" :style="{ left: menuLeft }">
      <a><li class="menu__item" @click="TabCloseCurrent()">关闭当前页</li></a>
      <a><li class="menu__item" @click="TabCloseOthers()">关闭其他页</li></a>
      <a><li class="menu__item" @click="TabCloseAll()">全部关闭</li></a>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      num: '0',


      activeName: sessionStorage.getItem('SelectPath') && sessionStorage.getItem('SelectPath') != '' ? sessionStorage.getItem('SelectPath') : sessionStorage.getItem('entity') == '管理员' ? '/Set/Set_basis' : sessionStorage.getItem('entity') == '咨询师' ? '/Consultant/ConsultantWork' : sessionStorage.getItem('entity') == '校长'  ? '/Set/Aggregate_statistics': sessionStorage.getItem('entity') == '危机管理员'  ? '/Set/Set_basisbeifen': '/index',
      
      editableTabs: sessionStorage.getItem('OpenTabs') && sessionStorage.getItem('OpenTabs') != '' ? JSON.parse(sessionStorage.getItem('OpenTabs')) : [sessionStorage.getItem('entity') == '管理员' ? { title: '工作台', name: 'Set_basis', path: '/Set/Set_basis'} :sessionStorage.getItem('entity') == '危机管理员' ? { title: '工作台', name: 'Set_basisbeifen', path: '/Set/Set_basisbeifen'} : sessionStorage.getItem('entity') == '咨询师' ? { title: '工作台',  name: 'ConsultantWork', path: '/Consultant/ConsultantWork', } : sessionStorage.getItem('entity') == '校长' ? { title: '总体统计', name: 'Aggregate_statistics', path: '/Set/Aggregate_statistics'}   :  { title: '首页', name: 'index',  path: '/index'}],



      // activeName: sessionStorage.getItem('SelectPath') && sessionStorage.getItem('SelectPath') != '' ? sessionStorage.getItem('SelectPath') : sessionStorage.getItem('entity') == '管理员' ? '/Set/Set_basis' : sessionStorage.getItem('entity') == '咨询师' ? '/Consultant/ConsultantWork' : sessionStorage.getItem('entity') == '校长' ? '/Set/Aggregate_statistics': '/index',editableTabs: sessionStorage.getItem('OpenTabs') && sessionStorage.getItem('OpenTabs') != '' ? JSON.parse(sessionStorage.getItem('OpenTabs')) : [sessionStorage.getItem('entity') == '管理员' ? { title: '工作台', name: 'Set_basis', path: '/Set/Set_basis'} : sessionStorage.getItem('entity') == '咨询师' ? { title: '工作台',  name: 'ConsultantWork', path: '/Consultant/ConsultantWork', } : sessionStorage.getItem('entity') == '校长' ? { title: '总体统计', name: 'Aggregate_statistics', path: '/Set/Aggregate_statistics'}  : { title: '首页', name: 'index',  path: '/index'}],
      tabIndex: 2,
      menuVisible: false,
      closeIndex: '',
      menuLeft: '',
    }
  },
  created() {

    // if(sessionStorage.getItem('entity') == '管理员'){
    //   this.editableTabs = { title: '工作台', name: 'Set_basis', path: '/Set/Set_basis'}
    // }else if(sessionStorage.getItem('entity') == '咨询师'){
    //   this.editableTabs = { title: '工作台',  name: 'ConsultantWork', path: '/Consultant/ConsultantWork', }
    // }else if(sessionStorage.getItem('entity') == '校长'){
    //   this.editableTabs = { title: '总体统计', name: 'Aggregate_statistics', path: '/Set/Aggregate_statistics'}
    // }else if(sessionStorage.getItem('entity') == '来访者'){
    //   this.editableTabs = { title: '首页', name: 'index',  path: '/index'}
    // }


    // if(sessionStorage.getItem('entity') == '咨询师'){
    //   this.activeName = '/Consultant/ConsultantWork'
    // }else if(sessionStorage.getItem('entity') == '校长'){
    //   this.activeName = '/Set/Aggregate_statistics'
    // }else if(sessionStorage.getItem('entity') == '管理员'){
    //   this.activeName = '/Set/Set_basis'
    //   // if(sessionStorage.getItem('RoleID') == '1068'){//危机管理员
    //   //   this.activeName = '/Set/Set_basisbeifen'
    //   // }else if(sessionStorage.getItem('RoleID') == '1057'){//系统管理员
    //   //   this.activeName = '/Set/Set_basis'
    //   // }
    // }else if(sessionStorage.getItem('entity') == '来访者'){
    //   this.activeName = '/index'
    // }





    this.$router.push(this.activeName);
  },
  //   beforeCreate(){
  //   if(sessionStorage.getItem('SelectPath') && sessionStorage.getItem('SelectPath')){
  //     if(sessionStorage.getItem('entity') == '咨询师'){
  //       this.activeName = '/Consultant/ConsultantWork'
  //     }else if(sessionStorage.getItem('entity') == '校长'){
  //       this.activeName = '/Set/Aggregate_statistics'
  //     }else if(sessionStorage.getItem('entity') == '管理员'){
  //       this.activeName = '/Set/Set_basis'
  //     }
  // },
  methods: {
    handleClick(tab) {
      this.$router.push(tab.$attrs.url);
    },
    handleTabsEdit(targetName, action) {//删除
      if (action === 'remove') {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.path === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.path;
              }
            }
          })
        }
        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter((tab) => tab.path !== targetName);
      }
    },
    tabRemove(obj) {
      if (obj === this.activeName) {
        this.$router.push(this.editableTabs[this.editableTabs.length - 1].path);
      }
    },
    rightClick(e, cIndex) {
      this.closeIndex = cIndex;
      this.menuVisible = false;//先把模态框关死， 目的是第二次或者第n次右键鼠标的时候 它默认的是true
      this.menuVisible = true;//显示模态窗口， 跳出自定义菜单栏
      this.menuLeft = e.clientX - 300 + 'px';
      document.addEventListener('click', this.foo);//给整个 添加监听鼠标事件， 点击任何位置执行foo方法
    },
    foo() {
      //取消鼠标监听事件 菜单栏
      this.menuVisible = false;
      document.removeEventListener('click',this.foo);
    },
    TabCloseCurrent() {
      let nowName = this.editableTabs[this.closeIndex].path;
      this.editableTabs.splice(this.closeIndex, 1);
      if (nowName === this.activeName) {
        this.$router.push(this.editableTabs[this.editableTabs.length - 1].path);
      }
    },
    TabCloseOthers() {
      let obj = this.editableTabs[this.closeIndex];
      this.editableTabs.splice(1, this.editableTabs.length);
      this.editableTabs.push(obj);
      this.$router.push(obj.path);
    },
    TabCloseAll() {
      this.editableTabs.splice(1, this.editableTabs.length);
      this.$router.push(this.editableTabs[0].path);
    },
  },
  watch: {
    //监听
    $route() {
      if ((this['$route'].name.toLowerCase().search('papertest') < 0 || this['$route'].name.toLowerCase().search('allpapertest') >= 0) && this['$route'].name.toLowerCase().search('setdepartment') < 0 && this['$route'].name.toLowerCase().search('modifyadd') < 0 && (this['$route'].name.toLowerCase().search('add') < 0 || this['$route'].name.toLowerCase().search('conaddress') >= 0)
      ) {
        let obj = {
          path: this.$route.fullPath,
          title: this.$route.meta.title ? this.$route.meta.title : this.$route.query.PageTitle,
          name: this.$route.name,
        }
        // 第一次登录true 危机统计，访谈整体报告，普测整体报告
        var isExist = this.editableTabs.some((x) => {
          this.activeName = x.path.split('?')[0];
          if (x.path.split('?')[0].indexOf('Admin/ExamineIndex') < 0) {
            return x.path.split('?')[0].toLowerCase() == obj.path.split('?')[0].toLowerCase()
          } else {
            if (x.path.split('?')[0].indexOf('Admin/ExamineIndex') > -1 && obj.path.split('?')[0].indexOf('Admin/ExamineIndex') > -1) {
              return true
            }
            else return false
          }
        })
        if(isExist){
          this.activeName = obj.path;//2024-02-02 解决导航栏不当前页面打开后， 不高亮显示问题
        }else{
          this.activeName = obj.path;
          this.editableTabs.push(obj);
        }
        // if (!isExist && sessionStorage.getItem('entity') != '校长') {
        //   this.activeName = obj.path;
        //   this.editableTabs.push(obj);
        // }else{
        //   this.activeName = obj.path;
        //   this.editableTabs.push(obj);
        // }
        sessionStorage.setItem('SelectPath', this.activeName)
        sessionStorage.setItem('OpenTabs', JSON.stringify(this.editableTabs))
      }
    },
  },
}
</script>
<style scoped>
.bg-purple-dark {
  background: #fff;
  height: 40px;
  margin-left: 10px;
  position: relative;
  z-index: 99999999999999;
}
.is-top {
  position: relative;
  z-index: 99999999999999;
  background-color: #fff;
}
.el-row {
  margin-bottom: 20px !important;
}
.el-tabs--card > .el-tabs__header {
  position: relative;
  z-index: 999999999;
  background-color: crimson;
  padding-left: 15px;
}

.menu__item {
  display: block;
  line-height: 20px;
  text-align: center;
  padding: 5px;
  color: #60666c;
}

.menu__item:hover {
  background-color: #deedfd;
  cursor: pointer;
  color: #2d6cd7;
}

.menu {
  height: 90px;
  width: 110px;
  position: absolute;
  border-radius: 5px;
  border: 1px solid #e6e8ea;
  background-color: #fff;
  z-index: 99999;
  padding-inline-start: 0px;
  padding: 3px;
}

.main-Menu .el-tabs--card > .el-tabs__header {
  padding-left: 15px;
}

.main-Menu  .el-tabs__item {
  height: 35px !important;
  line-height: 35px !important;
}
</style>
